import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import { useAuthStore } from '~/stores/useAuthStore'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'en-construccion' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    meta: { requiresAuth: true },
    redirect: { name: 'en-construccion' },
    children: [
      {
        name: 'en-construccion',
        path: 'en-construccion',
        component: () => import('../pages/WorkInProgress.vue'),
      },
      {
        name: 'panel-solicitudes',
        path: 'panel-solicitudes',
        component: () => import('../pages/admin/solicitudes/PanelSolicitudes.vue'),
      },
      {
        name: 'solicitudes-listado',
        path: 'listado-solicitudes/estado/:estado',
        component: () => import('../pages/admin/solicitudes/SolicitudesListado.vue'),
      },
      {
        name: 'solicitudes-listado-documentacion',
        path: 'listado-solicitudes/estado/:estado/documentacion/:documentacion',
        component: () => import('../pages/admin/solicitudes/SolicitudesListado.vue'),
      },
      {
        name: 'solicitudes-listado-documentacion-subestado',
        path: 'listado-solicitudes/estado/:estado/documentacion/:documentacion/:sub',
        component: () => import('../pages/admin/solicitudes/SolicitudesListado.vue'),
      },
      {
        name: 'dashboard-old',
        path: 'dashboard-old',
        component: () => import('../pages/admin/dashboard/Dashboard-old.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'faq',
        path: '/faq',
        component: () => import('../pages/faq/FaqPage.vue'),
      },
      {
        name: 'panel-solicitudes-validadas',
        path: 'panel-solicitudes-validadas',
        component: () => import('../pages/admin/solicitudes/PanelSolicitudesValidadas.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach(async (to) => {
  const authStore = useAuthStore()
  await authStore.fetchUser()

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return {
      name: 'login',
      query: { redirect: to.fullPath },
    }
  }
})

export default router
